/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserScopeSchema
 */
export interface UserScopeSchema {
    /**
     * 
     * @type {string}
     * @memberof UserScopeSchema
     */
    type?: UserScopeSchemaTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UserScopeSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserScopeSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserScopeSchema
     */
    email?: string;
}


/**
 * @export
 */
export const UserScopeSchemaTypeEnum = {
    User: 'user'
} as const;
export type UserScopeSchemaTypeEnum = typeof UserScopeSchemaTypeEnum[keyof typeof UserScopeSchemaTypeEnum];


/**
 * Check if a given object implements the UserScopeSchema interface.
 */
export function instanceOfUserScopeSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function UserScopeSchemaFromJSON(json: any): UserScopeSchema {
    return UserScopeSchemaFromJSONTyped(json, false);
}

export function UserScopeSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserScopeSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'id': json['id'],
        'name': json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function UserScopeSchemaToJSON(value?: UserScopeSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'id': value.id,
        'name': value.name,
        'email': value.email,
    };
}

